import { render, staticRenderFns } from "./RetailUser.vue?vue&type=template&id=1d8d5fce"
import script from "./RetailUser.vue?vue&type=script&lang=js"
export * from "./RetailUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports